if (!customElements.get('video-popup')) {
  customElements.define(
    'video-popup',

    class VideoPopup extends HTMLElement {
      constructor() {
        super();

        this.a11y = window.theme.a11y;
        this.dragStart = null;
        this.popupInitEventCallback = (e) => this.popupInit(e);
        this.pointerDownEventCallback = (e) => (this.dragStart = {x: e.clientX, y: e.clientY});
      }

      connectedCallback() {
        this.querySelectorAll('[data-video-play]').forEach((element) => {
          this.playButton = element;
          this.playButton.addEventListener('pointerdown', this.pointerDownEventCallback);
          this.playButton.addEventListener('click', this.popupInitEventCallback);
        });
      }

      popupInit(e) {
        const start = this.dragStart;
        this.dragStart = null;

        // Ignore the click a slider fires at the end of a drag (a swipe, not a tap).
        if (e.detail && start && (Math.abs(e.clientX - start.x) > 10 || Math.abs(e.clientY - start.y) > 10)) {
          e.preventDefault();
          return;
        }

        if (this.playButton.hasAttribute('data-video-play') && this.playButton.getAttribute('data-video-play').trim() !== '') {
          e.preventDefault();

          const items = [
            {
              html: this.playButton.getAttribute('data-video-play'),
            },
          ];
          const options = {
            mainClass: 'pswp--video',
          };

          this.a11y.state.trigger = this.playButton;
          new window.theme.LoadPhotoswipe(items, options);
        }
      }

      disconnectedCallback() {
        // used to prevent double click in slideshow - check after slideshow conversion
        this.querySelectorAll('[data-video-play]').forEach((element) => {
          this.playButton = element;
          this.playButton.removeEventListener('pointerdown', this.pointerDownEventCallback);
          this.playButton.removeEventListener('click', this.popupInitEventCallback);
        });
      }
    }
  );
}
